import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              观众热评
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              来自真实用户的使用体验，看看大家怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {comments.map((comment, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                    <div className="text-xs text-foreground-400">{comment.date}</div>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${
                        i < comment.rating
                          ? 'ri-star-fill text-accent-500'
                          : 'ri-star-line text-foreground-300'
                      }`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}